module.exports = __webpack_public_path__ + "img/BS.59b8c272.svg";